import dashboardIcon from '../../assets/icons/dashboard.svg'
import staffIcon from '../../assets/icons/staff-nav.svg'
import residentIcon from '../../assets/icons/resident-nav.svg'
import activitiesIcon from '../../assets/icons/activities-nav.svg'
import securityIcon from '../../assets/icons/security-nav.svg'
import servicesIcon from '../../assets/icons/services-nav.svg'
import walletIcon from '../../assets/icons/wallet-nav.svg'
import settingsIcon from '../../assets/icons/settings-nav.svg'
import feedbackIcon from '../../assets/icons/feedback-nav.svg'
import propertyListingIcon from '../../assets/icons/property-listing-nav.svg'
import logoutIcon from '../../assets/icons/logout-nav.svg'
import estateIcon from '../../assets/icons/estate-nav.svg'
import propertyIcon from '../../assets/icons/property-nav.svg'
import Dashboard from '../../pages/Dashboard'
import logout from '../../utils/logout'
import Staffs from '../../pages/Staffs'
import Estates from '../../pages/Estates'
import CreateEstate from '../../pages/Estates/EditEstate'
import Residents from '../../pages/Residents'
import ChangePassword from '../../pages/Settings/ChangePassword'
import EditProfile from '../../pages/Settings/EditProfile'
import EditEstates from '../../pages/Estates/EditEstates'
import Settings from '../../pages/Settings'
import Security from '../../pages/Security'
import Activities from '../../pages/Activities'
import Property from '../../pages/Property'
import Services from '../../pages/Services'
import Feedback from '../../pages/Feedback'

// import { EstateRoutes } from "../../pages/Estates/Routes";

export type SideNavItemType = {
  icon: string
  title: string
  path: string
  Page: () => JSX.Element
  onClick?: () => void
  permissions?: string[]
  children?: Omit<SideNavItemType, 'icon'>[]
}

export const mainSideNavItems: SideNavItemType[] = [
  {
    title: 'Dashboard',
    icon: dashboardIcon,
    path: 'dashboard',
    Page: Dashboard,
    permissions: ['admin'],
  },
  {
    title: 'Staffs',
    icon: staffIcon,
    path: 'staffs',
    Page: Staffs,
    permissions: ['admin', 'manage_staffs'],
  },
  {
    title: 'Residents',
    icon: residentIcon,
    path: 'residents',
    Page: Residents,
    permissions: ['admin', 'manage_res'],
  },

  {
    title: 'Activities',
    icon: activitiesIcon,
    path: 'activities',
    Page: Activities,
    permissions: ['admin'],
  },
  {
    title: 'Security',
    icon: securityIcon,
    path: 'security',
    Page: Security,
    permissions: ['admin', 'manage_security'],
  },
  {
    title: 'Services',
    icon: servicesIcon,
    path: 'services',
    Page: Services,
    permissions: ['admin'],
  },
  {
    title: 'Wallet',
    icon: walletIcon,
    path: 'wallet',
    Page: Dashboard,
    permissions: ['admin', 'manage_fin'],
  },
  {
    title: 'Property',
    icon: propertyIcon,
    path: 'property',
    Page: Property,
    permissions: ['admin'],
  },
  {
    title: 'Estates',
    icon: estateIcon,
    path: 'estates',
    Page: Estates,
    permissions: [],
    children: [
      {
        title: 'Estates',
        path: ':estateId',
        Page: CreateEstate,
        permissions: [],
        children: [
          {
            title: 'Edit',
            path: 'edit',
            Page: EditEstates,
            permissions: [],
          },
        ],
      },
    ],
  },
  {
    title: 'Settings',
    icon: settingsIcon,
    path: 'settings',
    Page: Settings,
    permissions: [],
    children: [
      {
        title: 'Profile',
        path: 'settings',
        Page: Dashboard,
        permissions: [],
      },
      {
        title: 'ChangePassword',
        path: 'change-password',
        Page: ChangePassword,
        permissions: [],
      },
      {
        title: 'EditProfile',
        path: 'edit-profile',
        Page: EditProfile,
        permissions: [],
      },
    ],
  },
]

export const extraSideNavItems: SideNavItemType[] = [
  {
    title: 'Feedback',
    icon: feedbackIcon,
    path: 'feedback',
    Page: Feedback,
    permissions: [],
  },
  {
    title: 'Property Listing',
    icon: propertyListingIcon,
    path: 'properties-listing',
    Page: Dashboard,
    permissions: [],
  },
]

export const logoutSideNavItem: SideNavItemType = {
  title: 'Logout',
  icon: logoutIcon,
  path: '',
  Page: Dashboard,
  onClick: logout,
}
